@if (!allTipsEmpty()) {
	<div class="product-detail__extra-information">
		<h3 i18n="Care tips header@@product.detail.caretips">Care tips</h3>

		@if (filteredProductTips().length > 0) {
			<ul class="product-detail__producttips">
				@for (productTip of filteredProductTips(); track productTip.text) {
					@if (productTip.text !== null && productTip.text !== "") {
						<li class="product-detail__producttip">
							<span>
								<img class="product-detail__tip-icon"
								     [src]="productTip.icon"
								     [alt]="productTip.text" />
			                </span>
							{{ productTip.text }}
						</li>
					}
				}
			</ul>
		}
	</div>
}
